<template>
	<div v-if="canShow" class="ref-header" :class="clazz" :style="style">
		<reference-header-row v-for="(r, idx) of header.rows" :row="r" :edit="idx === 0 && !(ro || vm)" @edit="requestEditMode"></reference-header-row>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, onMounted} from "vue";
import usePart, {getter, type PartProps} from "../../Part";
import { ReferenceHeader, RowObjectHeader} from "@t/fd/editor/References.ts";
import {injectEnv} from "@fd/Environment.ts";
import ReferenceHeaderRow from "@fd/editors/reference/ReferenceHeaderRow.vue";
import type {Array, ArrayAddButton} from "@t/fd/layout/Array.ts";

const props = defineProps<PartProps>();
const rh = computed<ReferenceHeader>(() => props.part as ReferenceHeader);
const { visible, clazz, style, ro, vm, localData, formData } = usePart(props);
const env = injectEnv();
const emit = defineEmits(['edit']);

const header = ref<RowObjectHeader | null>(null);
const canShow = computed<boolean>(() => visible.value && header.value != null);


function endpointUrl() {
	let url =  rh.value.url;
	if (Array.isArray(rh.value.params)) {
		for (let par of rh.value.params) {
			let v;
			if (par.source === "static") v = par.value;
			else v = getter(localData.value as FormData, par.d, formData); // from data
			if (par.path) {
				url = url.replace("{" + par.name + "}", v);
			} else {
				url = env.net.urlParam(url, par.name, v);
			}
		}
	}
	return url;
}

function loadHeader() {
	let endpoint = endpointUrl();
	env.net.fetch(endpoint)
		.then((resp) => {
			if (resp.ok) {
				resp.json().then((h:RowObjectHeader) => {
					header.value = h;
				})
			}
		});
}

function requestEditMode() {
	emit("edit");
}

onMounted(() => {
	loadHeader();
});
</script>

<style>
.ref-header {
	justify-self: stretch;
}
</style>